import type { ObjectFieldTemplateProps } from '@rjsf/utils';
import { getUiOptions } from '@rjsf/utils';
import { Box, Typography } from '@mui/material';
import type { ReactElement } from 'react';

export function ObjectFieldTemplate({
  title,
  properties,
  uiSchema,
}: ObjectFieldTemplateProps): ReactElement {
  const uiOptions = getUiOptions(uiSchema);
  const showLabel = uiOptions.label;

  if (!title || !showLabel) {
    return (
      <Box className="vtwo:flex vtwo:flex-col vtwo:w-full">
        {properties.map((prop) => (
          <Box key={prop.name} className="vtwo:w-full">
            {prop.content}
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box
      component="fieldset"
      className="vtwo:border vtwo:border-plus-border vtwo:rounded-xl vtwo:p-8 vtwo:min-w-0 vtwo:w-full vtwo:bg-white"
    >
      <Typography
        variant="body2"
        component="legend"
        className="vtwo:font-medium vtwo:text-gray-700"
      >
        {title}
      </Typography>
      {properties.map((prop) => (
        <Box key={prop.name} className="vtwo:w-full">
          {prop.content}
        </Box>
      ))}
    </Box>
  );
}
